export const TransferSpaceOptionService = Symbol('TransferSpaceOptionService');
